/** /v2/console/event_groups/ — system-wide notification event groups. */
import { apiDelete, apiGet, apiPatch, apiPost } from './client';
import type { PaginatedResponse } from './blacklists';

export interface EventGroupRow {
  id: number;
  name: string;
  description: string | null;
  event_codes: string[];
  created_ts: string | null;
  updated_ts: string | null;
}

export interface EventGroupWriteInput {
  name: string;
  description?: string | null;
  event_codes: string[];
}

export interface EventGroupListParams {
  page?: number;
  page_size?: number;
  ordering?: string;
  search?: string;
}

const BASE = '/event_groups/';

export const eventGroupsApi = {
  list(params: EventGroupListParams) {
    return apiGet<PaginatedResponse<EventGroupRow>>(BASE, {
      params: {
        page: params.page,
        page_size: params.page_size,
        ordering: params.ordering || undefined,
        search: params.search || undefined,
      },
    });
  },
  retrieve(id: number) {
    return apiGet<EventGroupRow>(`${BASE}${id}/`);
  },
  create(body: EventGroupWriteInput) {
    return apiPost<EventGroupRow>(BASE, body);
  },
  update(id: number, body: Partial<EventGroupWriteInput>) {
    return apiPatch<EventGroupRow>(`${BASE}${id}/`, body);
  },
  remove(id: number) {
    return apiDelete<void>(`${BASE}${id}/`);
  },
  eventCodes() {
    return apiGet<string[]>(`${BASE}event_codes/`);
  },
};
